
export const EnKeyMaps = new Map([
  ['title', 'Success Stories'],
]);

export const ZhKeyMaps = new Map([
  ['title', '成功案例'],
]);
